import React, { useContext, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import UserContext from '../../context/UserContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const CustUpload = () => {
  const [files, setFiles] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [message, setMessage] = useState('');
  const fileInputRef = useRef(null);
  const { userInfo,uploadercustomers} = useContext(UserContext);
    const [customer,setCustomer ] = useState({});

  const nav = useNavigate();
  // Allowed file extensions
  const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'pdf', 'zip','ai','psd'];

  const [searchParams] = useSearchParams();
//console.log(searchParams.get("c"))

const {apiURL} = useContext(UserContext)


useEffect(() => {
    const getcust = async() => {
let tempcustomer = await  uploadercustomers?.filter(filt => filt._id === searchParams.get("c"))
 console.log(searchParams.get("c"))
console.log(tempcustomer)
setCustomer(tempcustomer[0])
    }
getcust()
},[uploadercustomers])

console.log(customer)

  // Get file extension
  const getFileExtension = (filename) => {
    return filename.split('.').pop().toLowerCase();
  };

  // Check if file is an image
  const isImage = (filename) => {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];
    return imageExtensions.includes(getFileExtension(filename));
  };

  // Handle drag events
  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  // Handle file drop
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const droppedFiles = Array.from(e.dataTransfer.files);
    processFiles(droppedFiles);
  };

  // Handle file input change
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    processFiles(selectedFiles);
    e.target.value = null; // Clear input for re-selection
  };

  // Process and validate files
  const processFiles = (newFiles) => {
    const validFiles = newFiles
      .filter((file) => {
        const extension = getFileExtension(file.name);
        if (!allowedExtensions.includes(extension)) {
          setErrorMessage(
            `File "${file.name}" is not supported. Allowed formats: JPG, JPEG, PNG, GIF, PDF, ZIP, AI, PSD`
          );
          return false;
        }
        return true;
      })
      .map((file) => ({
        file,
        name: file.name,
        size: (file.size / (1024 * 1024)).toFixed(2) + ' MB',
        progress: 0,
        status: 'Pending',
        previewUrl: isImage(file.name) ? URL.createObjectURL(file) : null, // No preview for PDFs or ZIPs
      }));

    if (validFiles.length > 0) {
      setFiles((prevFiles) => [...prevFiles, ...validFiles]);
      setErrorMessage(null);
    }
  };

  // Upload file with progress tracking
  const uploadFile = async (fileObj) => {
    if (!fileObj.file) {
      setMessage('Please select a file first');
      return;
    }

    // Update file status to Uploading
    setFiles((prevFiles) =>
      prevFiles.map((f) =>
        f.name === fileObj.name ? { ...f, status: 'Uploading', progress: 0 } : f
      )
    );

    const formData = new FormData();
formData.append('file', fileObj.file);
formData.append('uploadedby',null);
formData.append('uploadName', 'PLS Print');
formData.append('email',null);
formData.append('company',customer.company);
formData.append('csr',customer.csrrep?.email);
//console.log(formData)
    try {
      const response = await axios.post(`${apiURL}/files/prepressuploadFile`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          // Calculate progress percentage
          const total = progressEvent.total || 1; // Fallback to avoid division by zero
          const progress = Math.round((progressEvent.loaded * 100) / total);
          
          // Update progress for the specific file
          setFiles((prevFiles) =>
            prevFiles.map((f) =>
              f.name === fileObj.name
                ? { ...f, progress, status: progress === 100 ? 'Completed' : 'Uploading' }
                : f
            )
          );
        },
      });

      // Remove the file from the list and clean up preview URL
      setFiles((prevFiles) => {
        const fileToRemove = prevFiles.find((f) => f.name === fileObj.name);
        if (fileToRemove?.previewUrl) {
          URL.revokeObjectURL(fileToRemove.previewUrl);
        }
        return prevFiles.filter((f) => f.name !== fileObj.name);
      });
      setMessage(response.data.message);
    } catch (err) {
      console.error('Axios error:', err.message, err.response?.data);
      setFiles((prevFiles) =>
        prevFiles.map((f) =>
          f.name === fileObj.name ? { ...f, status: 'Failed', progress: 0 } : f
        )
      );
      setMessage(`Failed to upload file: ${err.response?.data?.error || err.message}`);
    }
  };

  // Remove file and clean up preview URL
  const removeFile = (fileName) => {
    setFiles((prevFiles) => {
      const fileToRemove = prevFiles.find((f) => f.name === fileName);
      if (fileToRemove?.previewUrl) {
        URL.revokeObjectURL(fileToRemove.previewUrl);
      }
      return prevFiles.filter((f) => f.name !== fileName);
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };



  // Trigger file input click
  const handleClick = () => {
    fileInputRef.current.click();
  };

  return (
    <div className="w-full mx-auto mt-20 px-[80px] bg-white rounded-lg shadow-lg">

      <div className="flex w-full">
      <div className="flex-3 text-center flex items-center justify-center "><h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">Upload Files</h2>
      </div> 
       <div className="flex-1" style={{ textAlign: 'right' }}>
          <button
            type="button"
            className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
            onClick={e => nav('/dashboard') }
          >
           Go to Dashboard
          </button>
        </div>
        </div>
      {errorMessage && (
        <div className="mb-4 p-4 bg-red-100 text-red-700 rounded-md">{errorMessage}</div>
      )}
      {message && (
        <div className="mb-4 p-4 bg-green-100 text-green-700 rounded-md">{message}</div>
      )}
   
      <div
        className={`border-2 border-dashed rounded-lg p-8 text-center ${
          isDragging ? 'border-blue-600 bg-blue-50' : 'border-gray-300 bg-gray-50'
        }`}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
      >
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          accept=".jpg,.jpeg,.png,.gif,.pdf,.zip"
          multiple
          className="hidden"
        />
        <p className="text-gray-600 mb-4">
          Drag and drop your files here or{' '}
          <button
            onClick={handleClick}
            className="text-blue-600 hover:text-blue-800 font-medium"
          >
            browse
          </button>
        </p>
        <p className="text-sm text-gray-500">
          Supported formats: JPG, JPEG, PNG, GIF, PDF, ZIP
        </p>
      </div>

      {/* File List with Previews and Send Button */}
      {files.length > 0 && (
        <div className="mt-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">Selected Files</h3>
          <ul className="space-y-4">
            {files.map((fileObj, index) => (
              <li
                key={index}
                className="border rounded-md p-4 bg-gray-50 flex items-start space-x-4"
              >
                <div className="w-32 h-32 flex-shrink-0">
                  {isImage(fileObj.name) ? (
                    <img
                      src={fileObj.previewUrl}
                      alt={fileObj.name}
                      className="w-full h-full object-contain rounded-md"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center bg-gray-200 rounded-md">
                      <span className="text-gray-500 text-sm">
                        {getFileExtension(fileObj.name).toUpperCase()} Preview
                      </span>
                    </div>
                  )}
                </div>
                <div className="flex-1">
                  <div className="flex justify-between items-center">
                    <div>
                      <p className="text-sm font-medium text-gray-700">{fileObj.name}</p>
                      <p className="text-xs text-gray-500">
                        Size: {fileObj.size} | Status: {fileObj.status}
                      </p>
                    </div>
                    <button
                      onClick={() => removeFile(fileObj.name)}
                      className="text-red-600 hover:text-red-800 text-sm"
                      aria-label={`Remove ${fileObj.name}`}
                    >
                      Remove
                    </button>
                  </div>
                  <div className="mt-2">
                    <div className="w-full bg-gray-200 rounded-full h-2.5">
                      <div
                        className={`h-2.5 rounded-full ${
                          fileObj.status === 'Failed'
                            ? 'bg-red-600'
                            : fileObj.status === 'Completed'
                            ? 'bg-green-600'
                            : 'bg-blue-600'
                        }`}
                        style={{ width: `${fileObj.progress}%` }}
                      >


                      </div>
                      
                    </div>
                    <p className="text-xs text-gray-500 mt-1">{fileObj.progress}%</p>
                    <br />   
                  </div>
                  {fileObj.status === 'Pending' ? (
                  
                    <button
                      onClick={() => uploadFile(fileObj)}
                      className="mt-2 text-white bg-blue-600 hover:bg-blue-700 font-medium rounded-lg text-sm px-4 py-2"
                      aria-label={`Upload ${fileObj.name}`}
                    >
                      Send File
                    </button>
                  ):  <div className="text-2xl text-center mt-[-30px]"><br />This area will auto close. Job Processing....</div>}
                </div>
               
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CustUpload;